import { render, staticRenderFns } from "./StatusChangeForm.vue?vue&type=template&id=582cc3e0&lang=pug&"
import script from "./StatusChangeForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./StatusChangeForm.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports